import { useContext } from "react";
import { getNeedsIcon } from "../../utils/gameUtils";
import NeedItem from "../NeedItem/NeedItem";
import UserContext from "../../context/UserContext";
import "./NeedsContainer.scss";

const NeedsContainer = () => {
  const { user } = useContext(UserContext);

  return (
    <div className="needs-container">
      <NeedItem
        oomsNeed={getNeedsIcon("energy", user.energyLevel)}
        percentage={user.energyLevel}
      />
      <NeedItem
        oomsNeed={getNeedsIcon("fuel", user.fuelLevel)}
        percentage={user.fuelLevel}
      />
      <NeedItem
        oomsNeed={getNeedsIcon("health", user.healthLevel)}
        percentage={user.healthLevel}
      />
    </div>
  );
};

export default NeedsContainer;
